export const findCookieByName = (name: string): string => {
  const cookies = document.cookie?.split?.(';') ?? []

  if (!cookies.length) {
    return ''
  }

  return cookies.reduce((cookiesResult, cookie) => {
    const [key, value] = cookie?.split?.('=') ?? []

    if (!key) {
      return cookiesResult
    }

    return key.trim() === name ? value.trim() : cookiesResult
  }, '')
}
